// Los dos módulos de UCampus a los que se salta desde acá.
//
// El trámite de titulación vive allá, no en esta app (ver `core/ucampus.py` y la
// sección "Expediente de titulación" de CLAUDE.md): lo que se guarda es una foto de
// lectura, y cuando hay que mover algo se va a UCampus. Por eso los enlaces.

/** Títulos y Grados: el módulo donde vive el trámite. */
export const MODULO_URL = "https://ucampus.uchile.cl/m/fcfm_titulacion2/";

/** Boletín de notas. Es el módulo entero: no recibe a quién mirar. */
export const BOLETIN_URL = "https://ucampus.uchile.cl/m/fcfm_bia/";

/**
 * El expediente de una persona.
 *
 * Con `carrCodigo` abre el de esa carrera; sin él, UCampus elige cuál de los dos
 * mostrar —licenciatura y título son expedientes distintos—.
 */
export function expedienteUrl(rut: number, carrCodigo?: number | null): string {
  const carrera = carrCodigo ? `&carr_codigo=${carrCodigo}` : "";
  return `${MODULO_URL}expediente?rut=${rut}${carrera}`;
}
